export const CONTACT_METHOD_UNKNOWN = 0
export const CONTACT_METHOD_EMAIL = 1
export const CONTACT_METHOD_TEXT = 3

export const PCSID_COOKIE = '_pcsid'
export const PCUID_COOKIE = '_pcUID'

export const LEAD_CATEGORY_MAP = {
  unknown: 0,
  unspecified: 1,
  sales: 2,
  parts: 3,
  service: 4,
  bodyshop: 5
} as Record<string, number>
